export default __webpack_public_path__ + "static/media/goopter-ecommerce-social-share.d9b75632.png";